export const radarOptions = {
  radar: {
    axes: {
      angle: 'feature',
      value: 'score',
      label: {
        fontSize: 10,
        padding: 5,
      },
      radar: {
        margin: { right: 50 },
      },
    },
  },
  data: {
    groupMapsTo: 'product',
  },
  toolbar: { enabled: false },
  height: '300px',
  color: {
    scale: { Ideal: '#d4bbff', User: '#3edbd9' },
  },
};

// UT30 is an unique code to identify each widget in the BPPR ecosystem
export const UT30N9J = '30C9R';

/* Start of Modal Form data */
export const productTitle = 'Cyber Resilience Assessment';
export const pageUrl = '/products/cyber-resilience-assessment';
export const pageTitle = 'Cyber Resilience Assessment';
export const object = 'Cyber Resilience Assessment Page';
export const location = 'CRA Form';
export const btnExport = 'Download PDF';

/* End */
export const apiUrl = (locale: string) => {
  return `https://sdp-api.cloud-platform.ibm.com/flashsystem/pricing/api/locales/${locale}/storefront?type=questions&refresh_redis=true`;
};

export const AWS_SALES =
  'https://aws.amazon.com/marketplace/pp/prodview-zw7rst7t566c2?sr=0-6&ref_=beagle&applicationId=AWSMPContessa';

export const SKELETON_IMAGE =
  'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAIAAAACCAQAAADYv8WvAAAAEElEQVR42mN8+p+BgRFEAAAWrwPLzYNPyAAAAABJRU5ErkJggg==';
